import React, { useEffect, useState } from "react";
import { database } from "../firebase";
import { useDispatch, useSelector } from "react-redux";

function SentCreditz() {
  const { currentUser } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
  }));

  const [sent, setSent] = useState([]);
  function getUserData(uid) {
    return new Promise((resolve, reject) => {
      return database.ref("users/" + uid).once("value", (snap) => {
        resolve(snap.val());
      });
    });
  }

  function getCreditzData(credid) {
    return new Promise((resolve, reject) => {
      return database.ref("creditz/" + credid).once("value", (snap) => {
        resolve(snap.val());
      });
    });
  }
  function pendingCreditz() {
    return database
      .ref(`/user-creditz/`)
      .once("value")
      .then(async (snapshot) => {
        const creditRequests = [];
        // const res = [];
        const response = [];
        snapshot.forEach((childSnapshot) => {
          creditRequests.push(childSnapshot.val());
        });
        const sentRequests = creditRequests
          .map((req) => {
            const obj = Object.values(req)[0];
            if (obj.uid == currentUser.uid) {
              return obj;


            }
          })
          .filter((e) => e);


       
        var newRes = await Promise.all(
        sentRequests.map(async (user) => {
        
            const Creddata = await getCreditzData(user.credid);
       return {
              ...sentRequests,
             
              Creditz: Creddata,
            };
          })
        );
     
        setSent(newRes);
      });
  }

  useEffect(() => {
    pendingCreditz();
  }, []);
  return (
    <>
      <div className="table-responsive">
        <table className="table align-middle text-center">
          <thead className="bg-lightblue-gradient text-primary fw-semibold">
            <tr>
              <td className="border-bottom">Sender</td>
              <td className="border-bottom">Artwork</td>
              <td className="border-bottom">Type</td>
              <td className="border-bottom">Title</td>
              <td className="border-bottom">Role</td>
            </tr>
          </thead>
          <tbody>
            {sent&&sent.map((sent) => {
              return (
                <tr key={sent.id}>
                  <td className="text-primary">{currentUser.fullName}</td>
                  <td>
                    <img
                      src={sent.Creditz.albumImage}
                      className="mmwh-45 rounded"
                      alt="received-user"
                    />
                  </td>
                  <td>{sent.Creditz.category}</td>
                  <td>{sent.Creditz.trackname}</td>
                  <td>
                    <span className="badge px-3 py-2 rounded-pill fw-medium bg-blue">
                      {currentUser.accountType}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
export default SentCreditz;
